<svg [attr.height]="size" [attr.width]="size" fill="none" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
  <path [attr.stroke]="color" d="M9.17004 14.8299L14.83 9.16992" stroke-linecap="round" stroke-linejoin="round"
        stroke-width="1.5"/>
  <path [attr.stroke]="color" d="M14.83 14.8299L9.17004 9.16992" stroke-linecap="round" stroke-linejoin="round"
        stroke-width="1.5"/>
  <path [attr.stroke]="color" d="M9 22H15C20 22 22 20 22 15V9C22 4 20 2 15 2H9C4 2 2 4 2 9V15C2 20 4 22 9 22Z"
        stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5"/>
</svg>
